
/**
 * Made by Proficient
 * Created on 31-05-2024
 * Updated on 31-05-2024
 */

async function getCart() {
  const res = await fetch('/cart.js')
  const data = await res.json()
  return data
}

async function isProductInCart(variantId) {
  if( !variantId ) {
    throw new Error('Missing variantId')
  }

  const cart = await getCart()

  if( cart.items.length == 0 ) {
    return false
  }

  const item = cart.items.find(item => item.variant_id == variantId)

  return !!item
}

async function addToCart(items = []) {
  if( items.length == 0 ) {
    return
  }

  if( !items instanceof Array ) {
    throw new Error('Items should be an array')
  }

  const formData = {
    items
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })

  const data = await res.json();

  return data
}

async function getProduct(handle) {
  const res = await fetch(`/products/${handle}.js`);
  const data = await res.json();
  return data;
}

async function removeFromCart(id) {
  if( !id ) {
    throw new Error('Missing id')
  }

  let updates = {
    [id]: 0,
  };

  const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })

  const data = await res.json();

  return data
}

if( window.proficient ) {
  if( window.proficient.utils ) {
    window.proficient.utils.cart = {
      addToCart,
      getProduct,
      removeFromCart,
      getCart,
      isProductInCart
    }
  }
}
